// Fixed display order for the four wage-category columns, independent of the
// order the backend returns `details` in.
export const MW_DETAIL_KEYS = ["Unskilled", "Semi-skilled", "Skilled", "Highly Skilled"];

// Effective From/To are stored inside the same `details` JSON alongside the wage-category
// keys above (Effective From required, Effective To optional - see AddEditMinimumWages.jsx
// buildPayload), and are also shown as their own list columns below.
export const MW_EFFECTIVE_FROM_KEY = "Effective From";
export const MW_EFFECTIVE_TO_KEY = "Effective To";

// Looks up a detail value by `key`, never by array index, so the UI stays
// correct even if the backend ever changes the order of `details`.
export const getDetailValue = (details, key) => {
  if (!Array.isArray(details)) return null;
  const item = details.find((d) => d.key === key);
  return item ? item.value : null;
};

// True existence check - distinguishes "key is absent" (e.g. Effective To was never set, or
// a legacy record predates this field) from "key is present with a falsy value", which
// getDetailValue's `null` return can't tell apart on its own.
export const hasDetailKey = (details, key) => Array.isArray(details) && details.some((d) => d.key === key);

const formatAmount = (value) => (value === null || value === undefined || value === "" ? "-" : Number(value).toLocaleString("en-IN"));

// Effective From/To display the raw stored JSON value as-is (e.g. "2026-08"); Effective To
// simply renders as an empty cell when its key isn't present in `details` - never "null",
// "undefined", or a placeholder like "N/A".
const formatEffectiveDate = (value) => value || "";

const getColumns = (handleEditMinimumWages, handleDelete) => [
  {
    label: "State",
    field: "state_name",
    className: "fw-semibold",
    sortable: true,
    render: (row) => row.state_name || row.state || "N/A",
  },
  ...MW_DETAIL_KEYS.map((key) => ({
    label: key,
    field: key,
    className: "text-end",
    sortable: false,
    render: (row) => formatAmount(getDetailValue(row.details, key)),
  })),
  {
    label: "Effective From",
    field: MW_EFFECTIVE_FROM_KEY,
    className: "text-center",
    sortable: false,
    render: (row) => formatEffectiveDate(getDetailValue(row.details, MW_EFFECTIVE_FROM_KEY)),
  },
  {
    label: "Effective To",
    field: MW_EFFECTIVE_TO_KEY,
    className: "text-center",
    sortable: false,
    render: (row) => formatEffectiveDate(getDetailValue(row.details, MW_EFFECTIVE_TO_KEY)),
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => (
      <span className={`badge ${row.status ? "bg-success" : "bg-danger"}`}>{row.status ? "Active" : "Inactive"}</span>
    ),
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleEditMinimumWages(row)} title="Edit">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div className="cursor-pointer text-danger" onClick={() => handleDelete(row.id)} title="Delete">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;
